<template>
    <el-drawer :visible.sync="drawer" direction="rtl" size="65%" :show-close="false">
        <div slot="title" class="drawer-title">
            <span class="title-line"></span>
            <span class="title-text">设置分享样式</span>
        </div>
        <div class="share-style-container">
            <!-- 左侧表单区域 -->
            <div class="form-section">
                <el-form :model="form" label-width="100px" class="share-form">
                    <el-form-item label="分享方式：" required>
                        <el-radio-group v-model="form.sharingMethod">
                            <el-radio :label="0">分享好友</el-radio>
                            <el-radio :label="1">分享朋友圈</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="分享标题：" required>
                        <el-input v-model="form.shareTitle" placeholder="请输入标题名称" maxlength="30" show-word-limit
                            @blur="trimShareTitle"></el-input>
                    </el-form-item>

                    <el-form-item label="分享描述：" required>
                        <el-input type="textarea" :rows="2" v-model="form.shareDescription" placeholder="请输入描述"
                            maxlength="50" show-word-limit @blur="trimShareDescription"></el-input>
                    </el-form-item>
                    <el-form-item label="封面图片：" required v-if="!form.sharingMethod">
                        <div class="upload-section">
                            <div class="cover-uploader" @click="openCropper">
                                <img v-if="form.coverImage" :src="coverImageUrl" class="cover-image">
                                <div v-else class="upload-placeholder">
                                    <i class="el-icon-plus plusIcon"></i>
                                    <div class="upload-text">点击上传</div>
                                </div>
                            </div>
                            <div class="file-types">支持扩展名：.jpg .png，建议尺寸比例 5:4（如 500×400px）</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="封面图片：" required v-else>
                        <div class="upload-section">
                            <div class="cover-uploader" @click="openCropper">
                                <img v-if="form.coverImageTwo" :src="coverImageTwoUrl" class="cover-image">
                                <div v-else class="upload-placeholder">
                                    <i class="el-icon-plus plusIcon"></i>
                                    <div class="upload-text">点击上传</div>
                                </div>
                            </div>
                            <div class="file-types">支持扩展名：.jpg .png，建议尺寸比例 1:1（如400×400px）</div>
                        </div>
                    </el-form-item>
                    <!-- 图片裁剪弹窗 -->
                    <el-dialog title="图片裁剪" :visible.sync="cropperVisible" width="600px" :close-on-click-modal="false"
                        append-to-body>
                        <div class="cropper-container">
                            <vue-cropper ref="cropper" :img="cropperImg" :output-size="1" :output-type="'png'"
                                :info="true" :can-scale="true" :auto-crop="true"
                                :auto-crop-width="form.sharingMethod == 1 ? 200 : 250"
                                :auto-crop-height="form.sharingMethod == 1 ? 200 : 200" :fixed="true"
                                :fixed-number="form.sharingMethod == 1 ? [1, 1] : [5, 4]" :full="true" :fixed-box="true"
                                :can-move="true" :can-move-box="true" :original="false" :center-box="true"
                                :max-img-size="3000" :enlarge="1" :mode="'contain'" />
                        </div>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="cropperVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirmCrop">确认裁剪</el-button>
                        </div>
                    </el-dialog>

                    <!-- 隐藏的文件上传input -->
                    <input type="file" ref="fileInput" style="display: none" accept=".jpg,.jpeg,.png"
                        @change="handleFileChange" />

                    <el-form-item>
                        <div class="image-preview-list">
                            <div class="preview-item" v-for="(item, index) in imageList" :key="index">
                                <img :src="item.url" class="preview-img">
                                <i class="el-icon-delete delete-icon" @click="deleteImage(index)"></i>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="启用：" class="enable-item" required>
                        <el-switch v-model="form.isEnable" :active-value="1" :inactive-value="0" active-color="#13ce66"
                            inactive-color="#ff4949"></el-switch>
                    </el-form-item>

                    <el-form-item class="note-item">
                        <div class="note-text">注：启用后，将按当前配置效果展示；未启用则使用系统默认分享样式</div>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 右侧预览区域 -->
            <div class="preview-section">
                <div class="phone-preview">
                    <div class="phone-frame">
                        <div class="phone-screen"
                            :class="{ 'bg-friend': !form.sharingMethod == 1, 'bg-moment': form.sharingMethod == 1 }">
                            <div class="share-card" :class="{ 'moment-layout': form.sharingMethod == 1 }"
                                :style="{ marginTop: !form.sharingMethod ? '20px' : '100px' }">
                                <template v-if="form.sharingMethod == 0">
                                    <div class="share-content">
                                        <div class="share-title">{{ form.shareTitle }}</div>
                                        <div class="share-desc">{{ form.shareDescription }}</div>
                                    </div>
                                    <div class="share-image">
                                        <img v-if="form.coverImage" :src="coverImageUrl">
                                        <div v-else class="empty-image">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </div>

                                </template>
                                <template v-else>
                                    <div class="share-image">
                                        <img v-if="form.coverImageTwo" :src="coverImageTwoUrl">
                                        <div v-else class="empty-image">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </div>
                                    <div class="share-content">
                                        <div class="share-title">{{ form.shareTitle }}</div>
                                        <!-- <div class="share-desc">{{ form.shareDescription }}</div> -->
                                    </div>

                                    <div class="mini-program-tag">
                                        <i class="el-icon-s-platform"></i>
                                        <span>小程序</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="drawer-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="saveShareStyle">保存</el-button>
        </div>
    </el-drawer>
</template>

<script>
import global from "@/config/global";
import { mapGetters } from "vuex";
import { VueCropper } from 'vue-cropper';
import {
    shareStyleAdd,
    sharestyleId,
    shareStyleEdit,
} from "@/api/slot";
export default {
    name: "setStyle",
    components: {
        VueCropper
    },
    computed: {
        ...mapGetters(["project"]),
        coverImageUrl() {
            if (!this.form.coverImage) return '';
            // 如果已经是完整URL，直接返回
            if (this.form.coverImage.startsWith('http')) return this.form.coverImage;
            // 拼接 filePath 前缀
            return this.project?.filePath ? this.project.filePath + this.form.coverImage : this.form.coverImage;
        },
        coverImageTwoUrl() {
            if (!this.form.coverImageTwo) return '';
            // 如果已经是完整URL，直接返回
            if (this.form.coverImageTwo.startsWith('http')) return this.form.coverImageTwo;
            // 拼接 filePath 前缀
            return this.project?.filePath ? this.project.filePath + this.form.coverImageTwo : this.form.coverImageTwo;
        }
    },
    data() {
        return {
            drawer: false,
            form: {
                shareTitle: '',
                shareDescription: '',
                coverImage: '',
                //是否启用（0否 1是）
                isEnable: 1,
                pagesId: '',
                sharingMethod: 0
            },
            imageList: [],
            currentRow: null,
            // 裁剪相关
            cropperVisible: false,
            cropperImg: '',
            cropperFile: null,

        }
    },
    mounted() {

    },
    watch: {
        drawer: {
            handler(newValue, oldValue) {
                if (!this.drawer) {
                    this.form = {}
                }
            },
            deep: true,
        },
    },
    methods: {
        // 分享标题失去焦点时去除首尾空格
        trimShareTitle() {
            if (this.form.shareTitle) {
                this.form.shareTitle = this.form.shareTitle.trim();
            }
        },
        // 分享描述失去焦点时去除首尾空格
        trimShareDescription() {
            if (this.form.shareDescription) {
                this.form.shareDescription = this.form.shareDescription.trim();
            }
        },
        // 打开文件选择
        openCropper() {
            this.$refs.fileInput.click();
        },
        // 处理文件选择
        handleFileChange(e) {
            const file = e.target.files[0];
            if (!file) {
                // 清空 input 值，允许重复选择同一文件
                e.target.value = '';
                return;
            }

            // 验证文件类型
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
                // 清空 input 值，允许重复选择同一文件
                e.target.value = '';
                return;
            }

            // 验证文件大小
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 5MB!');
                // 清空 input 值，允许重复选择同一文件
                e.target.value = '';
                return;
            }

            this.cropperFile = file;

            // 读取文件并显示裁剪框
            const reader = new FileReader();
            reader.onload = (e) => {
                this.cropperImg = e.target.result;
                this.cropperVisible = true;
            };
            reader.readAsDataURL(file);

            // 清空 input 值，允许重复选择同一文件
            e.target.value = '';
        },
        // 确认裁剪并上传
        confirmCrop() {
            this.$refs.cropper.getCropBlob((blob) => {
                // 将 blob 转换为 file
                const file = new File([blob], this.cropperFile.name, {
                    type: blob.type,
                    lastModified: Date.now()
                });

                // 上传文件
                this.uploadFile({ file });
                this.cropperVisible = false;
            });
        },
        uploadFile(item) {
            let file = item.file;
            Vue.prototype.$POST
                .upload(
                    global.baseApi + "admin/sys-file/upload",
                    {
                        file,
                        dir: "person",

                    },
                    {
                        baseURL: "",
                        timeout: 20000,
                    }
                )
                .then((res) => {
                    if (res.code == 0 || res.code === 200) {
                        // 保存文件名，显示时自动拼接 filePath 前缀
                        const fileName = res.data?.cdnUrl;
                        if (!this.form.sharingMethod) {
                            this.form.coverImage = fileName;
                        } else {
                            this.form.coverImageTwo = fileName;
                        }
                        this.$message.success("图片上传成功");
                    } else {
                        this.$message.error("图片上传失败");
                    }
                });
        },
        open(row) {
            this.form.pagesId = row.pagesId
            this.drawer = true;
            this.sharestyleInfo(row.pagesId)
        },
        //获取数据
        sharestyleInfo(id) {
            sharestyleId({ pagesId: id })
                .then((res) => {
                    if (res.code == 0) {
                        // 先保存 pagesId
                        const currentPagesId = id;
                        // 重置表单为默认值
                        this.resetForm();
                        // 恢复 pagesId
                        this.form.pagesId = currentPagesId;

                        if (res.data) {
                            // 合并数据，确保 sharingMethod 是数字类型
                            this.form = {
                                ...this.form,
                                ...res.data,
                                pagesId: currentPagesId
                            };
                        }
                        // 确保 sharingMethod 有值且为数字类型
                        if (this.form.sharingMethod === null || this.form.sharingMethod === undefined || this.form.sharingMethod === '') {
                            this.form.sharingMethod = 0;
                        } else {
                            // 转换为数字类型
                            this.form.sharingMethod = Number(this.form.sharingMethod);
                        }
                    }
                })
                .catch((err) => {
                    // this.$message.error(err.msg);
                });
        },
        handleClose() {
            this.drawer = false
            this.resetForm()
        },
        resetForm() {
            this.form = {
                shareTitle: '',
                sharingMethod: 0,
                shareDescription: '',
                coverImage: '',
                coverImageTwo: '',
                isEnable: 1,
                pagesId: ''
            }
            this.imageList = []
            this.currentRow = null
        },
        handleCoverSuccess(res, file) {
            this.form.coverImage = URL.createObjectURL(file.raw)
        },
        beforeCoverUpload(file) {
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 5MB!')
            }
            return (isJPG || isPNG) && isLt2M
        },
        deleteImage(index) {
            this.imageList.splice(index, 1)
        },
        saveShareStyle() {
            // 先去除首尾空格
            this.trimShareTitle();
            this.trimShareDescription();

            // 验证必填项
            if (this.form.sharingMethod == null || this.form.sharingMethod == undefined) {
                this.$message.error('请选择分享方式')
                return
            }
            if (!this.form.shareTitle) {
                this.$message.error('请输入分享标题')
                return
            }
            if (!this.form.shareDescription) {
                this.$message.error('请输入分享描述')
                return
            }
            if (!this.form.coverImage) {
                this.$message.error('请上传封面图片')
                return
            }
            if (this.form.isEnable == null || this.form.isEnable == undefined) {
                this.$message.error('请选择是否启用分享样式')
                return
            }
            console.log('saveShareStyle================', this.form)
            // 保存逻辑
            if (this.form.sharestyleId) {
                shareStyleEdit(this.form)
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "修改成功",
                                type: "success",
                            });
                            this.$emit('refresh')
                            this.handleClose()
                        }
                    })
                    .catch((err) => {

                    });
            } else {
                shareStyleAdd(this.form)
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "保存成功",
                                type: "success",
                            });
                            this.$emit('refresh')
                            this.handleClose()
                        }
                    })
                    .catch((err) => {

                    });
            }

        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload {
    width: 250px !important;
    height: 200px !important;
}

.plusIcon {
    color: #999;
    font-size: 32px !important;
}

.share-style-container {
    display: flex;
    height: calc(100vh - 120px);
    padding: 20px;

    .form-section {
        flex: 1;
        padding-right: 40px;
        overflow-y: auto;

        .share-form {
            .el-form-item {
                margin-bottom: 12px;
            }

            // 调整 textarea 字数限制位置到底部
            ::v-deep .el-textarea {
                .el-input__count {
                    bottom: -4px !important;
                    right: 10px !important;
                    background: transparent !important;
                }
            }

            .upload-section {
                .cover-uploader {
                    border: 1px dashed #d9d9d9;
                    border-radius: 6px;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                    width: 250px;
                    height: 200px;
                    background: #fafafa;

                    &:hover {
                        border-color: #409eff;
                    }

                    ::v-deep .el-upload {

                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .cover-image {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        background-color: #f5f5f5;
                    }

                    .upload-placeholder {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                        padding: 20px;
                        box-sizing: border-box;

                        .upload-text {
                            margin-top: 12px;
                            font-size: 12px;
                            color: #666;
                            text-align: center;
                            line-height: 1.5;
                            width: 100%;
                            word-break: break-all;

                            .blue-text {
                                color: #409eff;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .file-types {
                    margin-top: 8px;
                    font-size: 12px;
                    color: #999;
                }
            }

            .image-preview-list {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;

                .preview-item {
                    position: relative;
                    width: 80px;
                    height: 80px;
                    border-radius: 4px;
                    overflow: hidden;
                    border: 1px solid #e0e0e0;

                    .preview-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .delete-icon {
                        position: absolute;
                        top: 4px;
                        right: 4px;
                        color: #fff;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 50%;
                        padding: 2px;
                        cursor: pointer;
                        font-size: 12px;
                    }
                }
            }

            .enable-item {
                margin-bottom: 10px;
            }

            .note-item {
                margin-bottom: 0;

                .note-text {
                    font-size: 12px;
                    color: #999;
                    line-height: 1.5;
                }
            }
        }
    }

    .preview-section {
        width: 420px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .preview-tabs {
            display: flex;
            margin-bottom: 20px;
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #ff6b35;

            .tab-item {
                padding: 10px 30px;
                font-size: 14px;
                cursor: pointer;
                background: #fff;
                color: #ff6b35;

                &.active {
                    background: #ff6b35;
                    color: #fff;
                }

                &:first-child {
                    border-right: 1px solid #ff6b35;
                }
            }
        }

        .phone-preview {
            .phone-frame {
                width: 280px;
                height: 560px;
                border: 12px solid #333;
                border-radius: 30px;
                position: relative;
                overflow: hidden;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 120px;
                    height: 20px;
                    background: #333;
                    border-radius: 0 0 12px 12px;
                    z-index: 10;
                }

                .phone-screen {
                    width: 100%;
                    height: 100%;
                    padding: 40px 15px 20px;
                    overflow-y: auto;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;

                    &.bg-friend {
                        background-image: url('https://cdn.zhaosheng.daheyun1314.com/training/fff4b87313d2481d9a051b23df8d2efe.png');
                    }

                    &.bg-moment {
                        background-image: url('https://cdn.zhaosheng.daheyun1314.com/training/40960723f9e646c4ad5ce59a979fa667.png');
                    }

                    .share-card {
                        background: rgba(255, 255, 255, 1);
                        border-radius: 8px;
                        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        margin-top: 100px;

                        &.moment-layout {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 12px;
                            margin-top: 50px;

                            .share-content {
                                flex: 1;
                                padding: 0 0 0 12px;


                                .share-title {
                                    -webkit-line-clamp: 1;
                                    margin-bottom: 8px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    white-space: normal;
                                    word-break: break-all;
                                }

                                .share-desc {
                                    font-size: 12px;
                                    color: #666;
                                    white-space: normal;
                                    word-break: break-all;
                                    line-height: 16px;
                                    margin-bottom: 0;
                                }
                            }

                            .share-image {
                                width: 80px;
                                height: 80px;
                                flex-shrink: 0;
                                border-radius: 4px;
                                overflow: hidden;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            .mini-program-tag {
                                display: none;
                            }
                        }

                        .share-content {
                            padding: 12px;

                            .share-title {
                                font-size: 14px;
                                font-weight: bold;
                                color: #333;
                                margin-bottom: 8px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }

                            .share-desc {
                                font-size: 12px;
                                color: #666;
                                margin-bottom: 8px;
                                white-space: normal;
                                word-break: break-all;
                                line-height: 16px;
                            }

                            .share-price {
                                margin-bottom: 10px;

                                .price-label {
                                    font-size: 12px;
                                    color: #ff6b35;
                                    margin-right: 4px;
                                }

                                .price-symbol {
                                    font-size: 14px;
                                    color: #ff6b35;
                                    font-weight: bold;
                                }

                                .price-value {
                                    font-size: 24px;
                                    color: #ff6b35;
                                    font-weight: bold;
                                }

                                .price-original {
                                    font-size: 12px;
                                    color: #999;
                                    text-decoration: line-through;
                                    margin-left: 8px;
                                }
                            }
                        }

                        .share-image {
                            width: 100%;
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }

                            .empty-image {
                                color: #ccc;
                                font-size: 40px;
                            }
                        }

                        .coupon-bar {
                            display: flex;
                            background: linear-gradient(90deg, #ff6b35 0%, #ff8e53 100%);
                            color: #fff;
                            padding: 8px 12px;
                            align-items: center;
                            justify-content: space-between;

                            .coupon-left {
                                display: flex;
                                align-items: center;

                                .coupon-amount {
                                    font-size: 18px;
                                    font-weight: bold;
                                    margin-right: 8px;
                                }

                                .coupon-name {
                                    font-size: 12px;
                                    background: rgba(255, 255, 255, 0.2);
                                    padding: 2px 6px;
                                    border-radius: 2px;
                                }
                            }

                            .coupon-right {
                                font-size: 12px;
                                background: #fff;
                                color: #ff6b35;
                                padding: 4px 12px;
                                border-radius: 12px;
                            }
                        }

                        .mini-program-tag {
                            display: flex;
                            align-items: center;
                            padding: 8px 12px;
                            font-size: 12px;
                            color: #666;
                            border-top: 1px solid #eee;

                            i {
                                margin-right: 4px;
                                color: #07c160;
                            }
                        }
                    }
                }
            }
        }
    }
}

.drawer-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background: #fff;
    border-top: 1px solid #e0e0e0;
    text-align: left;

    .el-button {
        margin-left: 10px;
    }
}

::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding: 20px;

    span {
        font-size: 16px;
        font-weight: bold;
    }
}

::v-deep .el-drawer__body {
    padding: 0;
    overflow: hidden;
}

.cropper-container {
    height: 400px;
}

.drawer-title {
    display: flex;
    align-items: center;

    .title-line {
        width: 4px;
        height: 18px;
        background: #ff6b35;
        margin-right: 10px;
        border-radius: 2px;
    }

    .title-text {
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }
}

::v-deep .el-form-item__label {
    color: #333;
}
</style>
